<template>
  <v-menu
    ref="menu"
    v-model="menu"
    lazy
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template #activator="{ on }">
      <v-text-field
        :id="component_id"
        v-model="dateFormatted"
        :label="label"
        :rules="rules"
        :disabled="disabled"
        return-masked-value
        mask="##/##/####"
        ref="textfield"
        validate-on-blur
        @blur="blurValues"
        @keyup.enter.exact="$emit('keyupEnter')"
        @click="$emit('click')"
      >
        <!-- @keyup.h="updateValues(dateFormatted, false)" -->
        <template v-slot:append>
          <v-icon :id="component_id + '_calendar'" @click="openMenu()">event</v-icon>
        </template>
      </v-text-field>
    </template>

    <v-date-picker :id="component_id + '_date_picker'" ref="teste" reactive :disabled="disabled" locale="pt-br" style="display: table-cell;" @input="inputPicker" :value="value"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  data () {
    return {
      menu: false,
      dateFormatted: ''
    }
  },
  props: {
    component_id: {
      type: String,
      default: 'id'
    },
    value: {
      type: String
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    nullable: {
      type: Boolean,
      default: true
    },
    rules: {}
  },
  watch: {
    value (val) {
      this.setDateFormatted(val)
    }
  },
  mounted () {
    this.setDateFormatted()
  },
  methods: {
    inputPicker (val) {
      this.updateValues(this.moment(val), 'blur')
    },
    inputField (val) {
      this.dateFormatted = val
    },
    openMenu (e) {
      this.$emit('click')
      // caso não tenha data selecionada, já preenche com a data atual
      if (!this.value) {
        this.dateFormatted = this.moment().format('DD/MM/YYYY')
        this.updateValues()
      }
      this.menu = true
    },
    blurValues () {
      // Caso o menu (picker) esteja aberto, não precisa fazer o update Values, pois ele já sera feito no method inputPicker
      // Como passa o valor em formato brasileiro, então coloca pro moment receber em DD/MM/YYYY
      if (!this.menu) this.updateValues(this.moment(this.dateFormatted, 'DD/MM/YYYY'), 'blur')
    },
    // event serve para saber qual emit sera acionado apos mudar os valores
    updateValues (date = this.moment(this.dateFormatted, 'DD/MM/YYYY'), event = '') {
      let dateFormatted = ''
      if (date.isValid()) {
        dateFormatted = date.format('YYYY-MM-DD')
      } else {
        // caso não tenha um valor e o nullable está ativo então limpa o campo
        // caso o nullable esteja desativo(a data não pode ser invalida ou vazia) então seta a data atual
        dateFormatted = (this.nullable) ? '' : this.moment().format('DD/MM/YYYY')
      }
      let result = dateFormatted ? this.moment(dateFormatted).format('YYYY-MM-DD') : ''
      this.$emit('input', result)
      if (event !== '') this.$emit(event, result)
      this.menu = false
    },
    setDateFormatted (val = this.value) {
      if (val) {
        this.dateFormatted = this.moment(val).format('DD/MM/YYYY')
      } else {
        this.dateFormatted = ''
        // tem que zerar o internalValue tbm pois quando era digitado uma data invalida e colocava vazio não estava recebendo o vazio.
        this.$refs.textfield.internalValue = ''
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/PDate.vue